module.exports = __webpack_public_path__ + "img/ge.40c9e78d.svg";